export default "__VITE_ASSET__CkavV6LF__";